@if (!online()) {
  <div
    class="bg-amber-600 text-white text-center text-sm py-2 px-4 font-medium z-50"
    role="status"
    aria-live="polite">
    You're offline. POS, orders and the dashboard keep working with the data
    synced to this device.
  </div>
}
